import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getFormattedPrice } from "@qgiv/core-donor";
import { ThemeType } from "../../../../../redux/constants";
import {
    selectAllRegistration,
    selectRegistrationTotals,
} from "../../../../../redux/slices/registrationSlice";
import { selectSpecificFormSetting } from "../../../../../redux/slices/formSettingsSlice";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import { selectRegistrationFeeDisplaySettings } from "../../../../../redux/slices/p2pSettingsSlice";
import { selectAllProductSettings } from "../../../../../redux/slices/productSettingsSlice";
import StoreCartList from "./StoreCartList";
import { selectIsCms } from "../../../../../redux/slices/configSlice";

const ConnectedStoreCartList = ({ formattedStoreTax, storeSubtotal }) => {
    const isCms = useSelector(selectIsCms);
    const { storeCart = [], shippingMethod = "" } = useSelector(
        selectAllRegistration,
    );
    const { shippingMethodAmount = 0 } = useSelector(selectRegistrationTotals);
    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pStore: { taxLabel = "Tax", shippingLabel = "Shipping" },
    } = themeSettings;
    const { registrationFeeDisplay, registrationFeeDisplayText } = useSelector(
        selectRegistrationFeeDisplaySettings,
    );
    const { taxRate = 0, offerShipping = false } = useSelector(
        selectAllProductSettings,
    );

    const formattedShippingCost = getFormattedPrice(
        shippingMethodAmount,
        currency,
        registrationFeeDisplay,
        registrationFeeDisplayText,
    );

    const displayShipping = offerShipping && shippingMethod.length > 0;
    const displayDivider = taxRate > 0 && formattedShippingCost.length > 0;
    const displayBottomDivider = !formattedStoreTax && !storeSubtotal;
    const storeCartListProps = {
        displayBottomDivider,
        displayDivider,
        formattedStoreTax,
        formattedShippingCost,
        displayShipping,
        shippingLabel,
        storeCart,
        taxLabel,
        taxRate,
        isCms,
        renderStoreCartItems: () => {},
    };

    return <StoreCartList {...storeCartListProps} />;
};

ConnectedStoreCartList.propTypes = {
    formattedStoreTax: PropTypes.string.isRequired,
    storeSubtotal: PropTypes.string.isRequired,
};

export default ConnectedStoreCartList;
